import api from './client';

export interface User {
  id: string;
  name: string;
  email: string;
  role: string;
  systemRole: string;
  tokenVersion?: number;
  sessionId?: string;
}

export interface AuthResponse { user: User; csrfToken?: string }

export const login = (email: string, password: string) => api.post<AuthResponse>('/auth/login', { email, password });
export const register = (name: string, email: string, password: string) => api.post<AuthResponse>('/auth/register', { name, email, password });
export const refresh = () => api.post<AuthResponse>('/auth/refresh');
export const updateProfile = (name: string) => api.patch<AuthResponse>('/auth/profile', { name });
export const changePassword = (currentPassword: string, newPassword: string) => api.post<{ success: boolean; reauthenticationRequired?: boolean }>('/auth/change-password', { currentPassword, newPassword });
export const logout = () => api.post<{ success: boolean }>('/auth/logout');
export const logoutAll = () => api.post<{ success: boolean }>('/auth/logout-all');
export const getMe = () => api.get<AuthResponse>('/auth/me');
export const getCsrfToken = () => api.get<{ csrfToken: string }>('/auth/csrf');
